import { BoardInboxScreen } from "@civala/investor-nexus-pitch"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/hub/communications")({
  component: BoardInboxScreen,
})
